var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 16,
    viewBox: "0 0 5 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49984 8.83301C2.96007 8.83301 3.33317 8.45991 3.33317 7.99967C3.33317 7.53944 2.96007 7.16634 2.49984 7.16634C2.0396 7.16634 1.6665 7.53944 1.6665 7.99967C1.6665 8.45991 2.0396 8.83301 2.49984 8.83301Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49984 2.99967C2.96007 2.99967 3.33317 2.62658 3.33317 2.16634C3.33317 1.7061 2.96007 1.33301 2.49984 1.33301C2.0396 1.33301 1.6665 1.7061 1.6665 2.16634C1.6665 2.62658 2.0396 2.99967 2.49984 2.99967Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49984 14.6663C2.96007 14.6663 3.33317 14.2932 3.33317 13.833C3.33317 13.3728 2.96007 12.9997 2.49984 12.9997C2.0396 12.9997 1.6665 13.3728 1.6665 13.833C1.6665 14.2932 2.0396 14.6663 2.49984 14.6663Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionButton);
export default __webpack_public_path__ + "static/media/action_button.9b09fc0e77f4705dca31e79a2d81d2c0.svg";
export { ForwardRef as ReactComponent };